import { makeStyles } from "@material-ui/core/styles"
import ChipMui from "@material-ui/core/Chip"

const useStyles = makeStyles({
  chip: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: 100
  }
})

const Chip = props => {
  const classes = useStyles()
  return <ChipMui {...props} size="small" className={classes.chip} />
}

export default Chip
